import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ABOUT, IMAGES } from "@/lib/data";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "10%"]);

  return (
    <section id="about" ref={ref} className="relative py-28 lg:py-36 bg-[#0A0A0A] border-y border-white/10" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
            <motion.img style={{ y }} src={IMAGES.producer} alt="Taps working in the studio" className="absolute inset-0 w-full h-[112%] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/70 via-transparent to-transparent" />
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7 order-1 lg:order-2"
        >
          <p className="text-[12px] tracking-[0.3em] uppercase text-white/40 mb-5">{ABOUT.overline}</p>
          <h2 className="font-heading uppercase tracking-tight text-white text-3xl lg:text-5xl leading-[0.98] max-w-xl">
            {ABOUT.lead}
          </h2>
          <div className="mt-8 space-y-5 max-w-xl">
            {ABOUT.paras.map((p, i) => (
              <p key={i} className="text-white/55 leading-relaxed text-[15px]">{p}</p>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
